import axios from "axios";

export const getAllcourses = async (signal) => {
  const { data } = await axios.get("/api/courses/get", {
    timeout: 20000,
    signal,
  });
  if (!Array.isArray(data)) throw new Error("Invalid course response");
  return data;
};
